import axios from 'axios';

const smslogin = axios.create({
  baseURL:
    process.env.NODE_ENV === 'production'
      ? 'https://smslogin.api.hkraft.no'
      : 'https://smslogin.api.hkraft.no',

  headers: {
    'content-type': 'application/json',
  },
});

const params = {
  key:
    process.env.NODE_ENV === 'production'
      ? 'AIzaSyA2kC3aIGK2LFjscPw1b9y2jYH6gqA6oOs'
      : 'AIzaSyCjYmmR9vDrMKqwwVEu0-PU3-mSw6A8gZs',
};

export default {
  requestSmsLoginCode(phoneNumber, callback) {
    smslogin
      .post(
        '/v1/login',
        {
          phonenumber: phoneNumber,
        },
        {
          params: params,
        }
      )
      .then(() => {
        return callback(true);
      })
      .catch(() => {
        return callback(false);
      });
  },

  /*
   * Fetch customer relations connected to the phone number
   */
  fetchActorsBySmsCode(smsCode, phoneNumber, successCallback, errorCallback) {
    smslogin
      .post(
        '/v1/actors',
        {
          code: smsCode,
          phonenumber: phoneNumber,
        },
        {
          params: params,
        }
      )
      .then(response => {
        return successCallback(response.data.actors);
      })
      .catch(() => {
        return errorCallback();
      });
  },

  /*
   * Fetch more details about a specific customer with consumption points
   */
  fetchActor(actorId, successCallback, errorCallback) {
    axios
      .get('https://hkraft.azure-api.net/customer-integrations/actor-data', {
        headers: {
          'ocp-apim-subscription-key': 'ba7ba1b5e2c2478984143eb34641d343',
        },
        params: {
          actor: actorId,
        },
      })
      .then(response => {
        return successCallback(response.data);
      })
      .catch(() => {
        return errorCallback();
      });
  },
};
